module.exports = __webpack_public_path__ + "static/img/56-1.43776de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/56-1.jpg
// module id = JOUY
// module chunks = 0